/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const PLAY_VIEWBOX = 24;

const PLAY_PATH =
  'M18.54 9.00003L8.87997 3.46003C8.35725 3.15819 7.76397 3.00006 7.16036 3.00172C6.55676 3.00338 5.96435 3.16476 5.4433 3.46947C4.92225 3.77417 4.49112 4.21135 4.19372 4.7366C3.89631 5.26185 3.74321 5.85646 3.74997 6.46003V17.58C3.74997 18.4871 4.11029 19.357 4.75167 19.9983C5.39304 20.6397 6.26293 21 7.16997 21C7.77041 20.999 8.36006 20.8404 8.87997 20.54L18.54 15C19.059 14.6996 19.49 14.268 19.7896 13.7485C20.0891 13.2289 20.2468 12.6397 20.2468 12.04C20.2468 11.4403 20.0891 10.8511 19.7896 10.3316C19.49 9.81206 19.059 9.38044 18.54 9.08003V9.00003ZM17.54 13.19L7.87997 18.81C7.66346 18.9327 7.41884 18.9972 7.16997 18.9972C6.9211 18.9972 6.67648 18.9327 6.45997 18.81C6.24407 18.6854 6.06479 18.5061 5.94015 18.2902C5.81552 18.0743 5.74993 17.8293 5.74997 17.58V6.42003C5.74993 6.17072 5.81552 5.9258 5.94015 5.70989C6.06479 5.49397 6.24407 5.31468 6.45997 5.19003C6.67738 5.06918 6.92127 5.00392 7.16997 5.00003C7.4185 5.00513 7.66211 5.07032 7.87997 5.19003L17.54 10.77C17.756 10.8946 17.9353 11.0739 18.06 11.2898C18.1847 11.5057 18.2504 11.7507 18.2504 12C18.2504 12.2494 18.1847 12.4943 18.06 12.7102C17.9353 12.9262 17.756 13.1054 17.54 13.23V13.19Z';

/** Default fill from Figma asset. */
export const PLAY_ICON_DEFAULT_FILL = '#61677F';

const iconPropTypes = {
  size: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Play (24×24 outline). Color via `fill` or CSS `color` + `currentColor`.
 * Pass `aria-label` when icon conveys meaning without adjacent text.
 */
const PlayIcon = ({
  size = 24,
  fill = 'currentColor',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${PLAY_VIEWBOX} ${PLAY_VIEWBOX}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', 'ds-icon--filled', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path d={PLAY_PATH} fill={fill} />
  </svg>
);

PlayIcon.propTypes = iconPropTypes;

export { PlayIcon };
export default PlayIcon;
